// extracted by css-extract-rspack-plugin
export default {"cls1":"live_stats-cls1_Z3Z","cls2":"live_stats-cls2_Tu1 live_stats-cls1_Z3Z"};